export enum SubModuloNome {
  // Cadastros
  CORRETORAS = 'Corretoras',
  COTACAO = 'Cotação',
  EMPRESA = 'Empresa',
  PROPOSTA = 'Proposta',
  AGENDA = 'Agenda',
  BENEFICIARIO = 'Beneficiário',
  PRODUTOS = 'Produtos',
  VENDEDORES = 'Vendedores',
  REDE_CREDENCIADA = 'Rede Credenciada',
  OPERADORAS = 'Operadoras',
  CONTRATOS = 'Contratos',
  CARENCIAS = 'Carências',
  CAMPANHAS = 'Campanhas',
  ENTIDADE = 'Entidade',
  PROPOSTA_GESTAO_SAUDE = 'Proposta - Gestão de Saúde',
  PROPOSTA_CADASTRO = 'Proposta - Cadastro',
  PROPOSTA_FINANCEIRO = 'Proposta - Financeiro',
  PROPOSTA_ELEGIBILIDADE = 'Proposta - Elegibilidade',
  GERENCIAR_LEAD = 'Gerenciar Lead',
  PROPOSTA_DOCUMENTO_INTERNO = 'Proposta - Documento - Interno',
  CRM_DEPARTAMENTO = 'Departamento',
  CRM_TIPO_ATENDIMENTO = 'Tipo de Atendimento',
  PROPOSTA_SOMENTE_NOVA_ADESAO = 'Proposta - Somente - Nova Adesão',
  LAYOUT_VIDA = 'Layout Vida',

  // Usuários
  GERENCIAR_USUARIOS = 'Gerenciar',

  // Permissões
  GERENCIAR_PERMISSOES = 'Gerenciar Permissões',
  DASHBOARD_AMDINISTRADOR = 'Dashboards - Administrador	',
  DASHBOARD_CADASTRO = 'Dashboards - Cadastro',
  DASHBOARD_CADASTRO_ANALISE_ELEGIBILIDADE = 'Dashboards - Cadastro - Análise - Elegibilidade',
  DASHBOARD_DECLINADA = 'Dashboards - Declinada',
  DASHBOARD_FINANCEIRO = 'Dashboards - Financeiro',
  DASHBOARD_A_VENCER = 'Dashboards - A - Vencer',
  DASHBOARD_COMERCIAL = 'Dashboards - Comercial',
  DASHBOARD_GERAL = 'Dashboards',
  DASHBOARD_GESTAO_SAUDE = 'Dashboards - Gestão - Saúde',
  MENU = 'Menu',
  MASSA_ATIVOS = 'Massa de Ativos',
}

